import * as React from "react";
import {
  UserProvider,
  prefetchCurrentUser,
} from "@/shared/queries/CurrentUser.tsx";
import { useIsLoggedIn } from "@/shared/queries/loggedInStatus.ts";
import { prefetchPrivacyNotice } from "@/shared/queries/privacyNotice.ts";
import { getCvPartner, skipFetchingUser } from "@/shared/util/getCvPartner.ts";
import { container, mainNav } from "./Index.css.ts";
import { Logo } from "./Logo.tsx";
import { Navigation } from "./Navigation.tsx";

export { headerHeight } from "./Index.css.ts";

function useSkipFetchingUser() {
  const isLoggedIn = useIsLoggedIn();

  const [currentPath, setCurrentPath] = React.useState(
    () => window.location.pathname,
  );

  React.useEffect(() => {
    return getCvPartner().subscribeToRouter(() => {
      setCurrentPath(window.location.pathname);
    });
  }, []);

  if (!isLoggedIn) {
    return true;
  }

  return skipFetchingUser(currentPath);
}

export const Header: React.FC = () => {
  const skipFetchingUser = useSkipFetchingUser();
  const isLoggedIn = useIsLoggedIn();

  React.useEffect(() => {
    if (!skipFetchingUser) {
      Promise.all([prefetchCurrentUser(), prefetchPrivacyNotice()]);
    }
  }, [skipFetchingUser]);

  return (
    <header className={mainNav}>
      <div className={container}>
        <Logo />
        {isLoggedIn && (
          <UserProvider>
            <Navigation />
          </UserProvider>
        )}
      </div>
    </header>
  );
};
